import type { GetStaticProps, GetServerSideProps } from "next"
// Components
import Head from "next/head"
import Layout from "@components/layout/index"
import PolicyPage from "@containers/policy"
// Libs
import type { ReactElement } from "react"
import type { NextPageWithLayout } from "./_app"
import assetPrefix from "@prefix"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
// Styles

const Policy: NextPageWithLayout = (props) => {
  return (
    <>
      <Head>
        <title>Privacy Policy</title>
        <meta name="description" content="Privacy Policy" />
        <link rel="icon" href={`${assetPrefix}images/favicon.ico`} />
      </Head>
      <PolicyPage {...props} />
    </>
  )
}

Policy.getLayout = function getLayout(page: ReactElement) {
  return <Layout>{page}</Layout>
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const locale = context.locale || "en"
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"]))
    }
  }
}

export default Policy
